<div class="projektaufgabe-container" class="mt-4">
  <!-- Header with Create Button -->
  <div class="flex justify-between items-center mb-6">
    <div class="flex items-center space-x-2">
    </div>

    <div class="flex space-x-2">
      <button 
        (click)="createProjektaufgabe()" 
        mat-stroked-button>
        <mat-icon class="mr-2 w-5 h-5">add</mat-icon>
        Neues Projekt
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-12">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    <span class="ml-4 text-gray-600">Lade Projektaufgaben...</span>
  </div>


  <!-- Active Projektaufgabe -->
  <div *ngIf="activeProjektaufgabe" class="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
    <div class="flex items-center justify-between gap-x-6">
      <div class="min-w-0 flex-1">
        <div class="flex items-start gap-x-3">
          <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ activeProjektaufgabe.beschreibung || 'Projektaufgabe' }}</p>
          <span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-500/20">
            Aktiv
          </span>
        </div>
        <div class="mt-2 flex items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
          <p class="whitespace-nowrap">
            <span class="font-medium">Einsatztyp:</span> 
            {{ getEinsatztypLabel(activeProjektaufgabe.einsatztyp) || 'Standard' }}
          </p>
          <svg viewBox="0 0 2 2" class="h-0.5 w-0.5 fill-current">
            <circle r="1" cx="1" cy="1" />
          </svg>
          <p class="truncate">
            <span class="font-medium">Techniker:</span> 
            {{ activeProjektaufgabe.techniker?.vorname }} {{ activeProjektaufgabe.techniker?.nachname || 'Nicht zugewiesen' }}
          </p>
        </div>
        <div class="mt-2 flex items-center gap-x-2 text-xs text-gray-500 dark:text-gray-400">
          <p class="truncate">
            <span class="font-medium">Periodizität:</span> 
            {{ getPeriodizitaetLabel(activeProjektaufgabe.periodizitaet) || 'Standard' }}
            <span *ngIf="shouldShowPeriodizitatSerie(activeProjektaufgabe.periodizitaet)" class="ml-1">
              ({{ getPeriodizitatSerieLabel(activeProjektaufgabe.periodizitat_serie) }})
            </span>
          </p>
        </div>
      </div>
             <div class="flex flex-col gap-y-2">
         <button 
           (click)="editProjektaufgabe(activeProjektaufgabe)"
           mat-raised-button >
           
           Bearbeiten
         </button>
       </div>
    </div>
  </div> 


  <!-- Content -->
  <div *ngIf="!isLoading" class="mt-8 flow-root">
    <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
        <table class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15">
          <thead>
            <tr>
              <th scope="col" class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Beschreibung</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Techniker</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Status</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Einsatztyp</th>
              <th scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Periodizität</th>
              <th scope="col" class="whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
                <span class="sr-only">Aktionen</span>
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
            <tr 
              *ngFor="let projektaufgabe of projektaufgaben; let i = index" 
              class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150 cursor-pointer"
              [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}"
              (click)="editProjektaufgabe(projektaufgabe)">
              <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                <div class="max-w-xs truncate" [title]="projektaufgabe.beschreibung">
                  {{ projektaufgabe.beschreibung }}
                </div>
              </td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ projektaufgabe.techniker?.vorname }} {{ projektaufgabe.techniker?.nachname || '-' }}</td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                <span class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
                      [ngClass]="getActivationStatusClasses(projektaufgabe.is_active)">
                  <mat-icon class="text-sm mr-1">{{ projektaufgabe.is_active ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
                  {{ projektaufgabe.is_active ? 'Aktiv' : 'Inaktiv' }}
                </span>
              </td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">{{ getEinsatztypLabel(projektaufgabe.einsatztyp) }}</td>
              <td class="whitespace-nowrap px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                {{ getPeriodizitaetLabel(projektaufgabe.periodizitaet) }}
                <span *ngIf="shouldShowPeriodizitatSerie(projektaufgabe.periodizitaet)" class="ml-1 text-gray-400">
                  ({{ getPeriodizitatSerieLabel(projektaufgabe.periodizitat_serie) }})
                </span>
              </td>
              <td class="whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                <div class="flex space-x-2">
                  <button
                    *ngIf="!projektaufgabe.is_active"
                    (click)="activateProjektaufgabe(projektaufgabe); $event.stopPropagation()"
                    mat-button
                    color="primary"
                    class="slim-button">
                    <mat-icon class="text-sm mr-1">play_arrow</mat-icon>
                    Aktivieren
                  </button>
                  <button
                    *ngIf="projektaufgabe.is_active"
                    (click)="deactivateProjektaufgabe(projektaufgabe); $event.stopPropagation()"
                    mat-button
                    color="warn"
                    class="slim-button">
                    <mat-icon class="text-sm mr-1">pause</mat-icon>
                    Deaktivieren
                  </button>
                  <button 
                    (click)="editProjektaufgabe(projektaufgabe); $event.stopPropagation()"
                    mat-button
                    color="primary"
                    class="slim-button">
                    Bearbeiten
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Empty State - Only show when not loading and no data -->
  <div *ngIf="!isLoading && projektaufgaben.length === 0" class="text-center py-12">
    <mat-icon class="text-gray-400 w-16 h-16 mb-4">assignment</mat-icon>
    <p class="text-gray-500 text-lg mb-2">Keine Projektaufgaben gefunden</p>
    <p class="text-gray-400">Erstellen Sie eine neue Projektaufgabe oder passen Sie Ihre Filter an.</p>
  </div>

  <!-- Pagination -->
  <mat-paginator
    *ngIf="totalPages > 1"
    [length]="totalItems"
    [pageSize]="pageSize"
    [pageIndex]="currentPage - 1"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of project tasks">
  </mat-paginator>
</div>
